export default "skymp5-front/4989850929c2aaf823af66774846ae29.png";